<template>
  <div class="elements-item-quantity">
    <span>
      {{ $t('confirmation.quantity') }}
    </span>

    <!-- :disabled="ten_required"  NEED TO FIGURE THIS OUT -->
    <!-- NEED TO FIGURE OUT DEPOSITS -->

    <select
      id="itemQuantityDropdown"
      v-model="itemQty"
      aria-label="Item Quantity"
      class="select required inline quantity form-control"
      @change="emitPackageQty()"
    >
      <option
        v-for="n in inventoryOptions"
        :key="n"
        :value="n"
      >
        {{ n }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import cartApi from '../../cart_api'

export default {

  props: {
    candelete: {
      default: null,
      type: String
    },
    disablesubtract:{
      default: false,
      type: Boolean
    },
    maxqty: {
      default: 10,
      type: Number
    },
    minqty: {
      default: 1,
      type: Number
    },
    hotel: {
      default: false,
      type: Boolean
    },
    quantity: {
      default: null,
      type: Number
    },
    item: {
      default: () => {},
      type: Object

    },
    updating: {
      default: false,
      type: Boolean
    }
  },

  data(){
    return {
      itemQty: 1,
    }
  },

  computed: {

    inventoryOptions(){
      console.log(this.qtyRequirementExists)
      if(this.qtyRequirementExists && !this.hotel){
        return this.requiredQtyPossibilities
      }  else {
        return this.possibilities
      }
    },

    possibilities(){
      let array = []
      for (let i = this.minqty; i <=this.maxqty; i++) {
        array.push(i)
      }
      return array
    },

    requiredQtyPossibilities(){
      return Array.from({length: this.maxqty}, (_, i) => i + 1).filter( (qty) => {
        return qty % this.item.quantity_required == 0
      })
    },

    qtyRequirementExists(){
      return this.item && this.item.quantity_required
    },
    isBookingPortal() {
      return typeof window !== 'undefined' && window.booking_portal === 'true'
    },
    parkingPassItem(){
      if(this.item && this.parkingPass && !this.isBookingPortal){
        return this.quantity >= this.item.parking_pass_max_qty
      } else {
        return false
      }
    },

    parkingPass(){
      return this.item && this.item.parking_pass==true
    },
    cartdisabled(){
      return this.$store.state.order.order.disabled_cart
    },

    order(){
      return this.$store.state.order.order
    },

    deposit_qty_match(){
      return (this.order && this.order.deposit_qty_exact_match ? 'hidden disable' : '')
    },

    ten_required(){
      return this.item && this.item.ten_required
    }
  },

  watch: {
    item() {
      this.updateItemQty()
    }
  },

  created(){
    this.updateItemQty()
  },

  methods: {
    ...mapMutations('order',['updateLoading']),
    ...mapActions('order', ['getBackendOrder']),

    emitPackageQty() {
      this.updateLoading(true)
      let body = null
      if(this.hotel){

        body = JSON.stringify({room_quantity: this.itemQty})
      }else {
        body = JSON.stringify({quantity: this.itemQty})
      }
      cartApi.changeOrderItem(this.item.id, 'PUT', body).then(resp => {
        if(resp && this.item.room_quantity > this.itemQty){
          this.getBackendOrder().then(() => {
            this.$emit('errors', this.$t('roomQtyError'))
            this.updateLoading(false)
          })
        } else {
          this.getBackendOrder().then(() => {
            this.updateLoading(false)
          })
        }
      })
    },

    updateItemQty(){
      if(this.hotel){
        this.itemQty = this.item.room_quantity
      } else if(this.item.min_package_qty > this.itemQty){
        this.itemQty = this.minqty
      } else {
        this.itemQty = this.item.quantity
      }
    },
  }
}

</script>
